import React from 'react';
import './Contact.css';
import { Header } from '../components/Header';
import {Footer} from '../components/Footer';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';

const encode = (data) => {
	return Object.keys(data)
		.map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
		.join('&');
};

const handleSubmit = async (e) => {
	e.preventDefault();

	const form = e.target;

	const data = {
		'form-name': form.getAttribute('name'),
		service: form.service.value,
		nom: form.nom.value,
		telephone: form.telephone.value,
		email: form.email.value,
		ville: form.ville.value,
		message: form.message.value,
		accord: form.accord.checked ? 'oui' : 'non',
	};

	try {
		await fetch('/', {
			method: 'POST',
			headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
			body: encode(data),
		});

		alert('Message envoyé ✅');
		form.reset();
	} catch (error) {
		alert('Erreur ❌');
	}
};

const Contact = () => {
  return (
			<div class='bg-light'>
				<Header></Header>
				<br />
				<center>
					<h2>
						<span class='badge rounded-pill text-danger text-bg-danger bg-opacity-50'>Contact</span>
					</h2>
					<br />
					<h1>Demandez votre devis gratuit</h1>
					<br />
					<p>Remplissez le formulaire ou contactez-nous directement</p>
					<br />
					<div class='container'>
						<div class='row'>
							<div class='col-sm-4'>
								<div class='card'>
									<div class='card-body text-start'>
										<div class='container'>
											<div class='row'>
												<div class='col-sm-2'>
													<span class='badge text-bg-danger bg-opacity-25'>
														<Phone color='#f7021b' />
													</span>
												</div>
												<div class='col-sm-10 text-start'>
													<h5 class='card-title'>Téléphone</h5>
													<h6 class='card-subtitle mb-2 text-body-secondary'>
														<a class='link' href='tel:0618767935' style={{ color: '#000', textDecoration: 'none' }}>
															06 18 76 79 35
														</a>
														<br />
														<a class='link' href='tel:0664345036' style={{ color: '#000', textDecoration: 'none' }}>
															06 64 34 50 36
														</a>
													</h6>
													<p class='card-text'>Dépannage: 24h/24</p>
												</div>
											</div>
										</div>
									</div>
								</div>
								<br />
								<div class='card '>
									<div class='card-body text-start'>
										<div class='container'>
											<div class='row'>
												<div class='col-sm-2'>
													<span class='badge text-bg-danger bg-opacity-25'>
														<Mail color='#f7021b' />
													</span>
												</div>
												<div class='col-sm-10 text-start'>
													<h5 class='card-title'>Email</h5>
													<h6 class='card-subtitle mb-2 text-body-secondary'>
														<a class='link' href='mailto:epavistemoro@gmail.com' style={{ color: '#000', textDecoration: 'none' }}>
															epavistemoro@gmail.com
														</a>
													</h6>
													<p class='card-text'>Réponse sous 2h</p>
												</div>
											</div>
										</div>
									</div>
								</div>
								<br />
								<div class='card '>
									<div class='card-body text-start'>
										<div class='container'>
											<div class='row'>
												<div class='col-sm-2'>
													<span class='badge text-bg-danger bg-opacity-25'>
														<MapPin color='#f7021b' />
													</span>
												</div>
												<div class='col-sm-10 text-start'>
													<h5 class='card-title'>Adresse</h5>
													<h6 class='card-subtitle mb-2 text-body-secondary'>
														Résidence Lehena
														<br />
														521 Route d'Arcangues
														<br />
														64200 Bassussarry
													</h6>
												</div>
											</div>
										</div>
									</div>
								</div>
								<br />
								<div class='card text-bg-danger bg-gradient mb-3'>
									<div class='card-body text-start'>
										<div class='container'>
											<div class='row'>
												<div class='col-sm-2'>
													<span class='badge text-bg-light bg-opacity-25'>
														<Clock color='#fcf9f9' />
													</span>
												</div>
												<div class='col-sm-10 text-start'>
													<h5 class='card-title'>Horaires</h5>
													<p class='card-text'>
														Dépannage:
														<br />
														24h/24 - 7j/7
														<br />
														Bureau:
														<br />
														Lun-Sam: 8h-19h
													</p>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class='col-sm-8'>
								<div class='card text-start'>
									<br />
									<form class='m-5' name='contact' method='POST' data-netlify='true' action='/' onSubmit={handleSubmit}>
										<input type='hidden' name='form-name' value='contact' />
										<p>Type de service *</p>
										<select class='form-select' name='service' aria-label='Default select example' required>
											<option selected value=''>
												Sélectionnez un service
											</option>
											<option value='depannageauto'>Dépannage Auto</option>
											<option value='depannagemoto'>Dépannage Moto</option>
											<option value='remorquage'>Remorquage</option>
											<option value='enlèvementépave'>Enlèvement d'épave</option>
											<option value='rachatépave'>Rachat d'épave</option>
											<option value='videmaison'>Vide maison</option>
											<option value='evacuation'>Évacuation encombrants</option>
											<option value='autres'>Autres demandes</option>
										</select>
										<br />
										<div class='row g-3'>
											<div class='col'>
												<p>Nom complet *</p>
												<input type='text' name='nom' class='form-control' placeholder='Nom Prénom' aria-label='Nom complet' required />
											</div>
											<div class='col'>
												<p>Téléphone *</p>
												<input type='tel' name='telephone' class='form-control' placeholder='06 12 34 56 78' aria-label='Téléphone' required />
											</div>
										</div>
										<br />
										<div class='mb-3'>
											<label for='exampleFormControlInput1' class='form-label'>
												Adresse Email *
											</label>
											<input type='email' name='email' class='form-control' id='exampleFormControlInput1' placeholder='jean.dupont@example.com' required />
										</div>
										<div class='mb-3'>
											<label for='exampleFormControlInput1' class='form-label'>
												Ville *
											</label>
											<input type='city' name='ville' class='form-control' id='exampleFormControlInput1' placeholder='Bayonne' required />
										</div>
										<div class='mb-3'>
											<label for='exampleFormControlTextarea1' class='form-label'>
												Description de votre demande *
											</label>
											<textarea
												class='form-control'
												name='message'
												id='exampleFormControlTextarea1'
												rows='3'
												placeholder='Décrivez votre situation: type de véhicule, panne, adresse précise, nature des encombrants...'
												required
											></textarea>
										</div>
										<div class='col-12'>
											<div class='form-check'>
												<input class='form-check-input' type='checkbox' name='accord' value='accepte' id='invalidCheck2' required />
												<label class='form-check-label' for='invalidCheck2'>
													J'accepte que mes données soient utilisées pour me recontacter concernant ma demande *
												</label>
											</div>
										</div>
										<br />
										<div class='d-grid gap-2'>
											<button class='btn btn-danger btn-lg' type='submit'>
												Envoyer ma demande
											</button>
										</div>

										<hr></hr>
										<p class='mx-auto p-2' style={{ width: '500px' }}>
											* Champs obligatoires - Réponse garantie sous 2 heures
										</p>
									</form>
								</div>
							</div>
						</div>
					</div>
				</center>
				<br />
				<Footer></Footer>
			</div>
		);
};

export default Contact;
